import React, { useEffect, useState,Fragment } from "react";
import Cookies from "js-cookie";
// import VideoSection from "../components/partials/RejuvenationDetail/VideoSection";
import SkincareSliderSection from "../components/partials/SkincareDetail/SkincareSliderSection";

const Cosmetic = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => {
        if (prev !== currentLang) return currentLang;
        return prev;
      });
    }, 1000); // check every second

    return () => clearInterval(interval);
  }, []);

  const images = ["/assets/images/Cosmetic/Cosmetic-1.jpg"];

  const CosmeticSliderSectionTranslations = {
    en: {
      title: "Cosmetics",
      description:
        "Grab your essentials of makeup for face, eyes and lips that will leave your skin glowing all day and night.",
      button: "Order Now!",
    },
    ar: {
      title: "مستحضرات التجميل",
      description:
        "احصلي على مستلزمات المكياج الأساسية للوجه والعينين والشفاه لتمنحي بشرتك إشراقة تدوم طوال اليوم والليل.",
      button: "اطلب الآن!",
    },
  };

  return (
    <Fragment>
      <div className="container">
        <SkincareSliderSection
          translations={CosmeticSliderSectionTranslations}
          images={images}
          lang={language}
          link={"/order"}
        />
      </div>
      {/* <div className="container">
        <ProductGrid lang={language} kits={kits} translations={translations}  link={"/cosmetic-order-page"} />
      </div> */}
    
    </Fragment>
  );
};

export default Cosmetic;
